import MainMenuStore from './MainMenuStore'

export default MainMenuStore
